import { Component, OnInit, OnDestroy, Input } from '@angular/core'
import { Router, ActivatedRoute } from '@angular/router'
import { Subscription } from 'rxjs'

@Component({
  template: `
    <div class="mt-3 row">
      <div class="col-md-7 mb-3 d-flex justify-content-between flex-wrap">
        <mat-button-toggle-group
          *ngIf="!isRequesting"
          (change)="changeQueryParams($event)"
          [value]="activeGroup"
        >
          <mat-button-toggle value="active">Active</mat-button-toggle>
          <mat-button-toggle *ngIf="!isVideoSubscription" value="paused">Inactive</mat-button-toggle>
          <mat-button-toggle *ngIf="isVideoSubscription" value="draft">Draft</mat-button-toggle>
          <mat-button-toggle value="fulfilled">Fulfilled</mat-button-toggle>
          <mat-button-toggle value="deleted">Deleted</mat-button-toggle>
        </mat-button-toggle-group>
        <button
          *ngIf="searchActive"
          class="px-4 btn border border-solid border-light-gray"
          [class.mat-button-toggle-checked]="activeGroup === 'all'"
          (click)="search()"
        >All</button>
      </div>
      <div class="col-md-4 ml-auto">
        <div class="pl-2 input-group border border-light-gray rounded-sm">
          <input
            type="text"
            class="form-control border-0 shadow-none"
            (keyup.enter)="search()"
            [(ngModel)]="searchTerm"
            placeholder="Search by title or description"
            maxlength="32"
          >
          <div
            *ngIf="searchActive"
            class="input-group-append"
            (click)="searchActive = false; searchTerm = ''; search();"
          >
            <button type="button" class="btn">
              <i class="fas fa-times"></i>
            </button>
          </div>
          <div *ngIf="!searchActive" class="input-group-append" (click)="search()">
            <button type="button" class="btn">
              <i class="fas fa-search"></i>
            </button>
          </div>
        </div>
      </div>
    </div>
    <ng-content></ng-content>
  `,
  selector: 'keywords-layout'
})
export class KeywordsLayout implements OnInit, OnDestroy {
  @Input() isVideoSubscription: boolean
  routeObs: Subscription
  searchTerm = ''
  searchActive: boolean
  activeGroup: string
  isRequesting: boolean

  constructor(
    private router: Router,
    private route: ActivatedRoute,
  ) {}

  ngOnInit(): void {
    this.routeObs = this.route.queryParams.subscribe(queryParams => {
      this.searchTerm = queryParams['search']
      this.searchActive = queryParams['search'] ? true : false

      if (this.searchTerm && !queryParams['group']) {
        this.activeGroup = 'all'
      } else {
        this.activeGroup = queryParams['group'] || 'active'
      }
    })
    this.isRequesting = window.location.pathname.includes('topics/new')
  }

  search(): void {
    this.activeGroup = 'all'
    this.searchActive = true
    this.router.navigate(['./'], {relativeTo: this.route.parent, queryParams: {search: this.searchTerm}})
  }

  ngOnDestroy(): void {
    if (this.routeObs) this.routeObs.unsubscribe()
  }

  changeQueryParams(event):void {
    this.router.navigate(['./'], {relativeTo: this.route.parent, queryParams: {search: this.searchTerm, group: event.value}})
  }
}
